import "../css/metabox.scss";

// Import the all-mighty AlpineJS
import Alpine from "alpinejs";
import collapse from '@alpinejs/collapse'

// Component to bootstrap our site
// import App from "../../plugin-legacy/src/modules/app";

// import any components you might want to use now:
// import { initSelectPostComponent } from "./modules/selectPost";
// import { initLegacyComponent } from "./modules/plugin-legacy";
// import { initLegacySelectMdlComponent} from "./modules/legacySelectMdl";
// import { initAddRemoveComponent } from "./modules/addRemove";
// import { initSliderAdmin } from "./modules/slideradmin";
// import { initSelectPressphoto } from "./modules/selectPressphoto";
// import { initSelectLinkedMdl } from "./modules/selectLinkedMdl";
import { inithandleFocus } from "./handleFocus";


const App = (fn) => {
    if (document.readyState != "loading") {
      fn();
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
};
  
// Start the app!

App(() => {
    inithandleFocus();
    Alpine.plugin(collapse)
    // Already use alpine in theme
    // initAlpine();
});

function initAlpine() {
    if(Alpine)
    Alpine.start();
}
